export default __webpack_public_path__ + "locales/ru/ChangeUserTypeDialog.json?hash=44d06c6bb8975d892a6e1d08e07e6d23";